import { render, staticRenderFns } from "./BtnInserirAnexo.vue?vue&type=template&id=2b062083&"
import script from "./BtnInserirAnexo.vue?vue&type=script&lang=js&"
export * from "./BtnInserirAnexo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports